/**
 * WordPress dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import { InspectorControls, InspectorAdvancedControls, BlockControls } from '@wordpress/block-editor';
import { applyFilters } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */

/**
 * Inspector controls
 */
class Inspector extends Component {
	render() {
		const hookPrefix = `gutenify-block-${ this.props.hookPrefix }`;
		return (
			<Fragment>
				<BlockControls>
					{ applyFilters( `${ hookPrefix }-block-controls`, [], this.props ) }
				</BlockControls>
				<InspectorControls>
					{ applyFilters( `${ hookPrefix }-inspector-controls`, [], this.props ) }
				</InspectorControls>
				<InspectorAdvancedControls>
					{ applyFilters( `${ hookPrefix }-inspector-advance-controls`, [], this.props ) }
				</InspectorAdvancedControls>
			</Fragment>
		);
	}
}

export default Inspector;
